import {ReactNode} from 'react';
import styled from "styled-components";
import Header from "../Header";
import FooterSection from "../FooterSection";

interface IndexProps {
    children: ReactNode;
}

const PageLayout = ({children}: IndexProps) => {

    return (
        <Wrapper>
            <Header />
            <Main>
                {children}
            </Main>
            <FooterSection />
        </Wrapper>
    );
}

export default PageLayout;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;


const Main = styled.main`
    flex: 1;
`;
